export default "__VITE_ASSET__Cz5eoooA__"